import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import './index.css';
import App from './App';
import AdminDashboard from './pages/AdminDashboard';
import { TermsPage, PrivacyPage, SupportPage } from './pages/LegalPage';
import ConditionPage from './pages/ConditionPage';
import BlogIndex from './pages/BlogIndex';
import BlogPost from './pages/BlogPost';
import reportWebVitals from './reportWebVitals';
import "./i18n";

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <React.StrictMode>
        <HelmetProvider>
            <BrowserRouter>
                <Routes>
                    <Route path="/admin" element={<AdminDashboard />} />
                    <Route path="/terms" element={<TermsPage />} />
                    <Route path="/privacy" element={<PrivacyPage />} />
                    <Route path="/support" element={<SupportPage />} />
                    <Route path="/psoriasis" element={<ConditionPage slug="psoriasis" />} />
                    <Route path="/eczema" element={<ConditionPage slug="eczema" />} />
                    <Route path="/acne" element={<ConditionPage slug="acne" />} />
                    <Route path="/rosacea" element={<ConditionPage slug="rosacea" />} />
                    <Route path="/vitiligo" element={<ConditionPage slug="vitiligo" />} />
                    <Route path="/hidradenitis" element={<ConditionPage slug="hidradenitis" />} />
                    <Route path="/alopecia" element={<ConditionPage slug="alopecia" />} />
                    <Route path="/urticaria" element={<ConditionPage slug="urticaria" />} />
                    <Route path="/perioral-dermatitis" element={<ConditionPage slug="perioral-dermatitis" />} />
                    <Route path="/seborrheic-dermatitis" element={<ConditionPage slug="seborrheic-dermatitis" />} />
                    <Route path="/prurigo-nodularis" element={<ConditionPage slug="prurigo-nodularis" />} />
                    <Route path="/blog" element={<BlogIndex />} />
                    <Route path="/blog/:slug" element={<BlogPost />} />
                    <Route path="*" element={<App />} />
                </Routes>
            </BrowserRouter>
        </HelmetProvider>
    </React.StrictMode>
);

reportWebVitals();
